import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  bgColorSubject: BehaviorSubject<string> = new BehaviorSubject<string>('bg-white');
  bgColor$: Observable<string> = this.bgColorSubject.asObservable();

  constructor() {
    this.setBgColor();
  }

  setBgColor(bgColor: string | null = null): void {
    if (!bgColor) {
      // se non mi viene passato il bg color lo prendo dal local storage
      const JSONBgColor: string | null = localStorage.getItem('bgColor');
      // se nel local storage non c'è vuol dire che è il primo accesso e imposto il colore nel ls a bianco
      if (!JSONBgColor) return this.setBgColor('bg-white');

      this.bgColorSubject.next(JSONBgColor);
    } else {
      localStorage.setItem('bgColor', bgColor);
      this.bgColorSubject.next(bgColor);
    }
  }
}
